// extracted by mini-css-extract-plugin
export var desktopLayout = "DocsLayout-module--desktopLayout--23cb0";
export var mainArea = "DocsLayout-module--mainArea--2545f";
export var mainContent = "DocsLayout-module--mainContent--b8371";
export var mobileNavButton = "DocsLayout-module--mobileNavButton--6f15d";
export var sidebar = "DocsLayout-module--sidebar--16ac2";
export var sidebarHeader = "DocsLayout-module--sidebarHeader--6da70";
export var sidebarNav = "DocsLayout-module--sidebarNav--a481c";